<template>
    <div class="main">
        <myheader></myheader>
        <div class="mains">
            <div class="lanmu">
                <div class="top">群接龙</div>
            </div>
            <div class="tableTop">
                <el-button type="default" size="medium" icon="el-icon-arrow-left" @click="index">返回列表</el-button>
                <span class="text_top">群接龙 / 出价记录</span>
            </div>
            <div class="content flex">
                <div class="contents">
                    <!-- 接龙列表 -->
                    <div class="tableWrap">
                        <el-table
                            v-loading="loading"
                            element-loading-text="加载中"
                            :data="tableData"
                            style="width: 100%"
                            height="610">
                            <el-table-column
                            type="index"
                            prop="xuhao"
                            label="序号"
                            width="70">
                            <template slot="header">
                                <div class="filterHeader">
                                    序号
                                </div>
                            </template>
                            </el-table-column>
                            <el-table-column
                            prop="purchase_order_no"
                            label="主订单号"
                            width="230">
                            <template slot="header" slot-scope="scope">
                                <div class="filterHeader">主订单号</div>
                            </template>
                            </el-table-column>
                            <el-table-column
                            prop="cate_name"
                            label="类别"
                            width="120">
                            <template slot="header" slot-scope="scope">
                                <div class="filterHeader">类别</div>
                            </template>
                            </el-table-column>
                            <el-table-column
                            prop="brand_name"
                            label="品牌"
                            width="120">
                            <template slot="header" slot-scope="scope">
                                <el-popover class="filterHeader"
                                    placement="bottom"
                                    trigger="click">
                                    <div class="pop-wrap">
                                        <div class="cleck-wrap">
                                            <el-input v-if="pinpaiRadio.length > 1" class="btn-search"
                                                placeholder="搜索"
                                                prefix-icon="el-icon-search"
                                                v-model="pinpaikeyInput"
                                                @change="pinpaichangeInput"
                                                clearable
                                                size="small">
                                            </el-input>
                                            <div class="check-box">
                                                <div class="sf scrollBox">
                                                    <el-radio-group v-model="selectedpinpaiRadio" @input="pinpaiInput">
                                                        <el-radio :label="item.brand_id" v-for="item in pinpaiRadio" :key="item.brand_id">{{  item.brand_name }}</el-radio>
                                                    </el-radio-group>
                                                </div>
                                            </div>
                                            <div class="footerWrap">
                                                <div class="btnWrap">
                                                    <el-button size="medium" class="nl-need-cancel-btn">取消</el-button>
                                                    <el-button size="medium" class="nl-need-sure-btn">确定</el-button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div slot="reference" style="cursor: pointer;">品牌<svg t="1782501535717" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="7766" width="200" height="200"><path d="M855.342766 151.46262c-6.056949-11.851932-18.984377-19.393699-33.219589-19.393699L101.903901 132.068921c-14.360056 0-27.412326 7.704472-33.396621 19.744693-5.988388 12.015661-3.845585 26.157753 5.520737 36.192294l255.896134 274.308483 0 309.339324c0 12.847609 7.895831 24.602328 20.389376 30.328749l189.116195 86.432535c5.154393 2.371 10.771321 3.515057 16.33913 3.515057 6.541997 0 13.090133-1.607614 18.926048-4.797259 10.718109-5.945409 17.427928-16.503882 17.809621-28.037567l12.957103-396.767536 245.078765-274.90507C859.543438 177.316451 861.425298 163.313529 855.342766 151.46262zM520.773827 804.275693l-117.384477-53.647851L403.38935 483.628836l127.858016 0L520.773827 804.275693zM550.774095 416.986019c-1.963725-0.299829-3.761674-1.090844-5.809309-1.090844L383.519814 415.895175 181.938726 199.803605l562.427506 0L550.774095 416.986019zM685.454494 524.008498l273.392624 0 0 59.759035-273.392624 0 0-59.759035ZM685.454494 654.104485l273.392624 0 0 59.759035-273.392624 0 0-59.759035ZM685.454494 773.618463l273.392624 0 0 59.759035-273.392624 0 0-59.759035Z" fill="#666666" p-id="7767"></path></svg></div>
                                </el-popover>
                            </template>
                            </el-table-column>
                            <el-table-column
                            prop="goods_name"
                            label="产品型号"
                            width="250">
                            <template slot="header" slot-scope="scope">
                                <el-popover class="filterHeader"
                                    placement="bottom"
                                    trigger="click">
                                    <div class="pop-wrap">
                                        <div class="cleck-wrap">
                                            <el-input v-if="xinghaoCheckbox.length > 1" class="btn-search"
                                                placeholder="搜索"
                                                prefix-icon="el-icon-search"
                                                v-model="xinghaokeyInput"
                                                @change="xinghaochangeInput"
                                                clearable
                                                size="small">
                                            </el-input>
                                            <div class="check-box">
                                                <div class="sf scrollBox">
                                                    <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">全选</el-checkbox>
                                                    <el-checkbox-group v-model="selectedxinghaoCheckbox" @change="handleCheckedxinghaoChange">
                                                        <el-checkbox v-for="item in xinghaoCheckbox" :label="item.goods_spec_id" :key="item.goods_spec_id">{{  item.spec_name }}</el-checkbox>
                                                    </el-checkbox-group>
                                                </div>
                                            </div>
                                            <div class="footerWrap">
                                                <div class="btnWrap">
                                                    <el-button size="medium" class="nl-need-cancel-btn">取消</el-button>
                                                    <el-button size="medium" class="nl-need-sure-btn">确定</el-button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div slot="reference" style="cursor: pointer;">产品型号<svg t="1782501535717" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="7766" width="200" height="200"><path d="M855.342766 151.46262c-6.056949-11.851932-18.984377-19.393699-33.219589-19.393699L101.903901 132.068921c-14.360056 0-27.412326 7.704472-33.396621 19.744693-5.988388 12.015661-3.845585 26.157753 5.520737 36.192294l255.896134 274.308483 0 309.339324c0 12.847609 7.895831 24.602328 20.389376 30.328749l189.116195 86.432535c5.154393 2.371 10.771321 3.515057 16.33913 3.515057 6.541997 0 13.090133-1.607614 18.926048-4.797259 10.718109-5.945409 17.427928-16.503882 17.809621-28.037567l12.957103-396.767536 245.078765-274.90507C859.543438 177.316451 861.425298 163.313529 855.342766 151.46262zM520.773827 804.275693l-117.384477-53.647851L403.38935 483.628836l127.858016 0L520.773827 804.275693zM550.774095 416.986019c-1.963725-0.299829-3.761674-1.090844-5.809309-1.090844L383.519814 415.895175 181.938726 199.803605l562.427506 0L550.774095 416.986019zM685.454494 524.008498l273.392624 0 0 59.759035-273.392624 0 0-59.759035ZM685.454494 654.104485l273.392624 0 0 59.759035-273.392624 0 0-59.759035ZM685.454494 773.618463l273.392624 0 0 59.759035-273.392624 0 0-59.759035Z" fill="#666666" p-id="7767"></path></svg></div>
                                </el-popover>
                            </template>
                            <template slot-scope="scope">
                                <div style="white-space: pre-line; text-align: left;">{{ scope.row.goods_name }}
                                    {{ scope.row.spec_name }}
                                </div>
                            </template>
                            </el-table-column>
                            <el-table-column
                            prop="task_win_count"
                            label="已成交数量/需求数量"
                            width="300">
                            <template slot="header" slot-scope="scope">
                                <div class="filterHeader">
                                    已成交数量/需求数量
                                </div>
                            </template>
                            <template slot-scope="scope">
                                <div class="price-items" style="flex: 3 1 0%; display: flex; align-items: center;">
                                    <div class="vertical_center price-items el-row el-row--flex">
                                        <div class="el-col el-col-12">
                                            <div class="scheduleCont_1_left_1 unborder internal_content" style="height: 1.25rem; border-color: rgb(235, 57, 53);">
                                                <div class="un_xg_1_3_1 internal_content" :style="{width:`${Number((scope.row.task_win_count / scope.row.task_total_num * 100).toFixed(0))}%`}">

                                                </div>
                                            </div>
                                        </div>
                                        <div class="el-col el-col-12" style="text-align: left;">
                                            <span style="margin-left: 5px;">{{ scope.row.task_win_count }}/{{ scope.row.task_total_num }}</span>
                                        </div>
                                    </div>
                                </div>
                            </template>
                            </el-table-column>
                            <el-table-column
                            prop="price"
                            label="我的出价"
                            width="140">
                            <template slot="header" slot-scope="scope">
                                <div class="filterHeader">
                                    我的出价
                                </div>
                            </template>
                            <template slot-scope="scope">
                                <div class="need-order-table-content">
                                    <div class="tradePrice">
                                        <div style="margin-top: 5px;"> ￥{{ scope.row.price }} </div>
                                    </div>
                                </div>
                            </template>
                            </el-table-column>
                            <el-table-column
                            prop="num"
                            label="出价数量"
                            width="120">
                            <template slot="header" slot-scope="scope">
                                <div class="filterHeader">
                                    出价数量
                                </div>
                            </template>
                            </el-table-column>
                            <el-table-column
                            prop="status"
                            label="需求单状态"
                            width="140">
                            <template slot="header" slot-scope="scope">
                                <div class="filterHeader">
                                    需求单状态
                                </div>
                            </template>
                            <template slot-scope="scope">
                                <div v-if="scope.row.status == 1" class="xgbaojia">竞价中<el-button size="small" type="primary" @click="xgbaojia(scope.row)">修改报价</el-button></div>
                                <div v-if="scope.row.status == 2" class="xgbaojia">已成交<el-button size="small" type="primary" @click="xgbaojia(scope.row)">修改报价</el-button></div>
                                <div v-if="scope.row.status == 3">未达成</div>
                                <div v-if="scope.row.status == 4">已撤销</div>
                            </template>
                            </el-table-column>
                            <el-table-column
                            prop="review_status"
                            label="审核状态"
                            width="150">
                            <template slot="header" slot-scope="scope">
                                <div class="filterHeader">
                                    审核状态
                                </div>
                            </template>
                            <template slot-scope="scope">
                                <div class="shenhe" v-if="scope.row.review_status == 0">无需审核</div>
                                <div class="shenhe" v-if="scope.row.review_status == 1">待审核<el-button v-if="scope.row.status == 2" size="small" type="primary" @click="handleDetail(scope.row)">报价记录</el-button></div>
                                <div class="shenhe" v-if="scope.row.review_status == 2">已通过<el-button v-if="scope.row.status == 2" size="small" type="primary" @click="handleDetail(scope.row)">报价记录</el-button></div>
                                <div class="shenhe" v-if="scope.row.review_status == 3">已拒绝<el-button v-if="scope.row.status == 2" size="small" type="primary" @click="handleDetail(scope.row)">报价记录</el-button></div>
                            </template>
                            </el-table-column>
                            <el-table-column
                            prop="create_time"
                            :formatter="dateFormat"
                            label="出价时间"
                            width="195">
                            <template slot="header" slot-scope="scope">
                                <div class="filterHeader">
                                    出价时间
                                </div>
                            </template>
                            </el-table-column>
                            <el-table-column
                            fixed="right"
                            prop="status"
                            label="操作"
                            width="175">
                            <template slot="header" slot-scope="scope">
                                <div class="filterHeader">
                                    操作
                                </div>
                            </template>
                            <template slot-scope="scope">
                                <el-popconfirm @confirm="handleChujia"
                                title="确定要撤销出价吗？">
                                    <el-button v-if="scope.row.status == 1" slot="reference" type="danger" @click="handleChexiao(scope.row)">撤销出价</el-button>
                                </el-popconfirm>
                            </template>
                            </el-table-column>
                        </el-table>
                        <div class="pageWrap">
                            <el-pagination
                                @size-change="handleSizeChange"
                                @current-change="handleCurrentChange"
                                :current-page.sync="page"
                                :page-sizes="0"
                                :page-size="limit"
                                layout="total, sizes, prev, pager, next, jumper"
                                :total="total">
                            </el-pagination>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- 修改报价弹窗 -->
        <div class="xgDialog">
            <el-dialog title="修改报价" :visible.sync="dialogFormVisible" width="400px" @open="wucangOpen" @close="wucangClose">
                <el-form>
                    <el-form-item label="出价" :label-width="formLabelWidth">
                        <el-input v-model="price" @input="changePrice" autocomplete="off" placeholder="请填写新的出价"></el-input>
                    </el-form-item>
                    <el-form-item label="数量" :label-width="formLabelWidth">
                        <el-input v-model="num" @input="changeNum" autocomplete="off" placeholder="请填写新的数量"></el-input>
                    </el-form-item>
                    <el-form-item label="仓库" :label-width="formLabelWidth">
                        <el-select v-model="values" @change="valusChange($event)" placeholder="请选择新的仓库">
                            <el-option v-for="item in wucang" :key="item.id" :label="item.warehouse_name" :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="" :label-width="formLabelWidth">
                        {{ wucangAddress }}
                    </el-form-item>
                </el-form>
                <div slot="footer" class="dialog-footer">
                    <el-button @click="xgCancel">取 消</el-button>
                    <el-button type="primary" @click="xgSure">确 定</el-button>
                </div>
            </el-dialog>
        </div>
        <!-- 报价记录弹窗 -->
        <div class="xgDialog">
            <el-dialog title="报价修改记录" :visible.sync="dialogDetailVisible" width="800px" @open="openDetail" @close="closeDetail">
                <el-table :data="detail" height="400">
                    <el-table-column prop="price_old" label="原出价">
                        <template slot-scope="scope">
                            ￥{{ scope.row.price_old }}
                        </template>
                    </el-table-column>
                    <el-table-column prop="price_new" label="新出价">
                        <template slot-scope="scope">
                            ￥{{ scope.row.price_new }}
                        </template>
                    </el-table-column>
                    <el-table-column prop="num_old" label="原数量"></el-table-column>
                    <el-table-column prop="num_new" label="新数量"></el-table-column>
                    <el-table-column prop="warehouse_id_old" label="原仓库">
                        <template slot-scope="scope">
                            {{ getNameByOld(scope.row) }}
                        </template>
                    </el-table-column>
                    <el-table-column prop="warehouse_id_new" label="新仓库">
                        <template slot-scope="scope">
                            {{ getNameByNew(scope.row) }}
                        </template>
                    </el-table-column>
                    <el-table-column prop="create_time" :formatter="dateFormat" label="修改时间" width="150"></el-table-column>
                </el-table>
            </el-dialog>
        </div>
    </div>
  </template>

  <script>
    import { myQuoteList, cancelQuote, myQuoteBrands, myQuoteSpecs, getWarehouseList, updateQuote, getQuoteLog } from "@/api";
    import myheader from "@/components/common/header";
    import myleft from "@/components/common/left";
      export default {
          data () {
              return {
                // 修改报价弹窗
                dialogFormVisible: false, // 修改报价弹窗
                price: '',
                num: '',
                warehouse_id: '',
                wucang: [],
                wucangAddress: '', // 仓库地址
                values: '', // 
                // 报价记录详情弹窗
                dialogDetailVisible: false,
                detail: [],

                limit: 8, //每页多少数据
                page: 1,
                total: '',
                // 出价数据
                tableData: [],
                chexiaoid: '',
                // 数据列表
                loading: false,
                // total: 0,
                // limit: 20, //每页多少数据
                // page: 1,
                // 品牌搜索框
                pinpaikeyInput: '',
                // 品牌选项
                selectedpinpaiRadio: '',
                pinpaiRadio: [],
                // 型号搜索框
                xinghaokeyInput: '',
                // 型号选项
                checkAll: false,
                isIndeterminate: false,
                selectedxinghaoCheckbox: [],
                xinghaoCheckbox: [],
                
                // 额度搜索框
                edukeyInput: '',
                // 额度选项
                selectededuRadio: '',
                eduRadio: [
                    {
                        id: 1,
                        name: 'T+2',
                        num: '4'
                    }
                ],
                // 时效搜索框
                shixiaokeyInput: '',
                // 时效选项
                selectedshixiaoRadio: '',
                shixiaoRadio: [
                    {
                        id: 1,
                        name: '当日 24:00'
                    },
                    {
                        id: 2,
                        name: '次日 24:00'
                    },
                    {
                        id: 3,
                        name: '后日 24:00'
                    },
                    {
                        id: 4,
                        name: '3日后到货'
                    },
                    {
                        id: 5,
                        name: '已过到货时效'
                    }
                ],

                form:{},
                values: '' // 出价数量

              }
            },
            components: {
                myheader: myheader,
                myleft: myleft
            },
            methods: {

                // 修改报价
                xgbaojia(row){
                    console.log(row);
                    this.renwuId = row.id; // 任务id
                    this.dialogFormVisible = true // 打开弹窗
                },

                // 填写出价
                changePrice(val){
                    this.price = val
                    // console.log(val)
                },

                // 填写数量
                changeNum(val){
                    this.num = val
                    // console.log(val)
                },

                // 仓库下拉
                getWarehouseList(){
                    getWarehouseList({}).then((res) => {
                        // console.log(res.data.data);
                        if (res.data.code == 1) {
                            this.wucang = res.data.data
                        }
                    });
                },

                // 修改报价打开事件
                wucangOpen(){
                    this.getWarehouseList(); // 弹窗显示调用仓库
                },
                
                // 修改报价关闭事件
                wucangClose(){
                    this.dialogFormVisible = false;
                    this.price = '';
                    this.num = '';
                    // this.wucang = [];
                    this.values = '';
                    this.wucangAddress = '',
                    this.warehouse_id = ''
                },

                // 修改报价弹窗取消事件
                xgCancel(){
                    this.dialogFormVisible = false;
                    this.price = '';
                    this.num = '';
                    // this.wucang = [];
                    this.values = '';
                    this.wucangAddress = '',
                    this.warehouse_id = ''
                },

                // 仓库下拉选择事件
                valusChange(val){
                    // console.log(val)
                    this.warehouse_id = val
                    this.wucang.forEach((item) => {
                        if (val === item.id) {
                            this.wucangAddress = item.address; // 地址
                        }
                    });
                },

                // 提交修改报价
                xgSure(){
                    updateQuote({
                        id: this.renwuId, // 接龙任务id
                        price: this.price, // 出价
                        num: this.num, // 供货数量
                        warehouse_id: this.warehouse_id // 仓库id
                    }).then((res) => {
                        // console.log(res.data.data);
                        if (res.data.code == 1) {
                            this.dialogFormVisible = false;
                            this.price = '';
                            this.num = '';
                            // this.wucang = [];
                            this.values = '';
                            this.wucangAddress = '',
                            this.warehouse_id = '';
                            this.$message({
                                type: 'success',
                                message: '修改报价成功'
                            });
                            this.myQuoteList(); // 重新调用出价记录
                        }else{
                            this.$message.error(res.data.msg);
                        }
                    });
                },

                // 报价记录详情
                handleDetail(row){
                    this.dialogDetailVisible = true;
                    // this.loading = true;
                    this.getQuoteLog(row.id);
                    this.getWarehouseList(); // 弹窗显示调用仓库
                },

                getQuoteLog(id) {
                    // this.loading = true;
                    getQuoteLog({
                        id: id
                    }).then((res) => {
                        // console.log(res);
                        // this.loading = false;
                        if (res.data.code == 1) {
                            this.detail = res.data.data.list;
                        }
                    });
                },

                // 获取仓库名称 原
                getNameByOld(row){
                    const matchedItem = this.wucang.find(o => o.id === row.warehouse_id_old);
                    return matchedItem ? matchedItem.warehouse_name : ''; // 如果没有匹配项，返回空字符串等。
                },

                // 获取仓库名称 新
                getNameByNew(row){
                    const matchedItem = this.wucang.find(o => o.id === row.warehouse_id_new);
                    return matchedItem ? matchedItem.warehouse_name : ''; // 如果没有匹配项，返回空字符串等。
                },

                // 返回列表
                index(){
                    this.$router.replace("/")
                },

                // 每页条数
                handleSizeChange(val) {
                    console.log(`每页 ${val} 条`);
                },
                // 当前页
                handleCurrentChange(page) {
                    // console.log(`当前页: ${page}`);
                    this.loading = true;
                    myQuoteList({
                        page: page,
                        limit: this.limit
                    }).then((res) => {
                        // console.log(res.data.data);
                        this.loading = false;
                        if (res.data.code == 1) {
                            this.tableData = res.data.data.list;
                        }
                    });
                },

                // 品牌筛选
                pinpaiInput(){
                    const selectedpinpaiItem = this.pinpaiRadio.find(item => item.brand_id === this.selectedpinpaiRadio); // 获取选中项的详细信息
                    console.log("id=" + this.selectedpinpaiRadio)
                    console.log("文字：", selectedpinpaiItem) // 获取选中项的详细信息，例如 name 和 id
                },
                // 品牌下拉数据
                myQuoteBrands(){
                    myQuoteBrands({}).then((res) => {
                        console.log(res);
                        // this.loading = false;
                        if (res.data.code == 1) {
                            this.pinpaiRadio = res.data.data;
                            // this.total = res.data.data.total // 数据总条数
                        }
                    });
                },

                // 型号筛选 全选
                handleCheckAllChange(val) {
                    if (val) {
                        this.selectedxinghaoCheckbox = this.xinghaoCheckbox.map(item => item.goods_spec_id); // 选中所有项的 ID
                        this.isIndeterminate = false;
                        console.log(this.selectedxinghaoCheckbox)
                    } else {
                        this.selectedxinghaoCheckbox = []; // 清除所有选中项
                    }
                },
                // 多选
                handleCheckedxinghaoChange(value) {
                    // 处理选中项变化的情况，例如更新全选状态等。
                    let checkedCount = value.length;
                    this.checkAll = checkedCount === this.xinghaoCheckbox.length; // 根据选中项更新全选状态
                    this.isIndeterminate = checkedCount > 0 && checkedCount < this.xinghaoCheckbox.length;
                    console.log(JSON.stringify(this.selectedxinghaoCheckbox)) // 输出[1, 2]
                    console.log(this.selectedxinghaoCheckbox.join(',')) // 输出1, 2
                },
                // 型号下拉数据
                myQuoteSpecs(){
                    myQuoteSpecs({}).then((res) => {
                        console.log(res);
                        // this.loading = false;
                        if (res.data.code == 1) {
                            this.xinghaoCheckbox = res.data.data;
                            // this.total = res.data.data.total // 数据总条数
                        }
                    });
                },

                // 额度筛选
                eduInput(){
                    const selectededuItem = this.eduRadio.find(item => item.id === this.selectededuRadio); // 获取选中项的详细信息
                    console.log("id=" + this.selectededuRadio)
                    console.log("文字：", selectededuItem) // 获取选中项的详细信息，例如 name 和 id
                },

                // 出价记录
                myQuoteList() {
                    this.loading = true;
                    myQuoteList({
                        page: this.page, // 当前页
                        limit: this.limit // 每页条数
                    }).then((res) => {
                        console.log(res);
                        this.loading = false;
                        if (res.data.code == 1) {
                            this.tableData = res.data.data.list;
                            this.total = res.data.data.total
                            // this.total = res.data.data.total // 数据总条数
                        }
                    });
                },

                // 撤销出价
                handleChexiao(row){
                    // console.log(row.id)
                    this.chexiaoid = row.id
                },
                handleChujia(){
                    cancelQuote({
                        ids: this.chexiaoid
                    }).then(res => {
                        // console.log(res);
                        if (res.data.code == 1) {
                            // this.page = 1;
                            this.$message({
                                type: 'success',
                                message: '撤销出价成功'
                            });
                            this.myQuoteList(); // 调用出价记录
                        }
                    }).catch(error => {
                        console.log(error);
                    });
                },


                // 日期范围回显
                changeDate(e) {
                    console.log(e[0], e[1]);
                    this.start_time = e[0]; // 开始日期
                    this.end_time = e[1]; // 结束日期
                },
                // 列表
                contractEntrustIndex() {
                    this.loading = true;
                    contract_entrust_index({
                        params: {
                            type: 'material'
                        }
                    }).then((res) => {
                        // console.log(res.data.data);
                        this.loading = false;
                        if (res.data.code == 1) {
                            this.tableData = res.data.data.data;
                            this.total = res.data.data.total // 数据总条数
                        }
                    });
                },
                // 委托单位列表
                basisEntrustIndex() {
                    this.loading = true;
                    basis_entrust_index().then((res) => {
                        // console.log(res.data.data);
                        this.loading = false;
                        if (res.data.code == 1) {
                            this.danweiList = res.data.data.data;
                        }
                    });
                },
                // 删除选中项
                deleteSelect() {
                    this.$confirm('此操作将永久删除数据, 是否继续?', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                        }).then(() => {
                            
                        var val = this.multipleSelection;
                        var multipleSelection = val.map(item => item['id']).join(','); // 勾选值数组转字符串

                        contract_entrust_del({
                            ids: multipleSelection
                        }).then(res => {
                            // console.log(res);
                            if (res.data.code == 1) {
                                this.page = 1;
                                this.contractEntrustIndex(); // 调用数据列表函数
                            }
                        }).catch(error => {
                            console.log(error);
                        });

                        this.$message({
                            type: 'success',
                            message: '删除成功!'
                        });
                        }).catch(() => {
                        this.$message({
                            type: 'info',
                            message: '已取消删除'
                        });          
                    });
                },
                // 筛选
                submitForm(formName) {
                    this.$refs[formName].validate((valid) => {
                        if (valid) {
                            // console.log(this.formInline.name);
                            this.loading = true;
                            contract_entrust_index({
                                params: {
                                    type: 'material',
                                    entrust_id: this.formInline.entrust_id,
                                    serial: this.formInline.serial,
                                    entrust_phone: this.formInline.entrust_phone,
                                    start_time: this.start_time,
                                    end_time: this.end_time,
                                    page: this.page
                                }
                            }).then((res) => {
                                // console.log(res.data.data);
                                this.loading = false;
                                if (res.data.code == 1) {
                                    this.tableData = res.data.data.data;
                                    this.total = res.data.data.total // 数据总条数
                                }
                            });
                        } else {
                            console.log('error submit!!');
                            return false;
                        }
                    });
                },
                // 当选择项发生变化时会触发该事件
                handleSelectionChange(val) {
                    this.multipleSelection = val;
                    // var multipleSelection = val.map(item => item['id']).join(','); // 勾选值数组转字符串
                    // console.log(multipleSelection)
                },
                // 行数据查看跳转任务单
                handleSee(row) {
                    console.log(row);
                },
                // 行数据查看
                handleClick(row) {
                    console.log(row);
                },
                // 行数据编辑
                handleEdit(row) {
                    console.log(row);
                },
                // 行数据删除
                handleDelete(row) {
                    // console.log(row.id);
                    this.$confirm('此操作将永久删除数据, 是否继续?', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                        }).then(() => {

                        contract_entrust_del({
                            ids: row.id
                        }).then(res => {
                            // console.log(res);
                            if (res.data.code == 1) {
                                this.page = 1;
                                this.contractEntrustIndex(); // 调用数据列表函数
                            }
                        }).catch(error => {
                            console.log(error);
                        });
                        
                        this.$message({
                            type: 'success',
                            message: '删除成功'
                        });
                        }).catch(() => {
                        this.$message({
                            type: 'info',
                            message: '已取消删除'
                        });          
                    });
                },
                // 每页条数
                handleSizeChange(val) {
                    console.log(`每页 ${val} 条`);
                },
                // 当前页
                // handleCurrentChange(page) {
                //     // console.log(`当前页: ${page}`);
                //     this.loading = true;
                //     contract_entrust_index({
                //         params: { page }
                //     }).then((res) => {
                //         // console.log(res.data.data);
                //         this.loading = false;
                //         if (res.data.code == 1) {
                //             this.tableData = res.data.data.data;
                //         }
                //     });
                // },
                // 时间戳转日期格式
                formatDate(timestamp) {
                    const date = new Date(timestamp);
                    return date.toLocaleDateString(); // 或者使用其他格式化方法，如 date.toLocaleString() 或其他库如 moment.js
                },
                dateFormat(row) {
                    let data = row.create_time * 1000
                    let dtime = new Date(data)
                    const year = dtime.getFullYear()
                    let month = dtime.getMonth() + 1
                    if (month < 10) {
                        month = '0' + month
                    }
                    let day = dtime.getDate()
                    if (day < 10) {
                        day = '0' + day
                    }
                    let hour = dtime.getHours()
                    if (hour < 10) {
                        hour = '0' + hour
                    }
                    let minute = dtime.getMinutes()
                    if (minute < 10) {
                        minute = '0' + minute
                    }
                    let second = dtime.getSeconds()
                    if (second < 10) {
                        second = '0' + second
                    }
                    return year+ '-' + month+ '-' + day + ' ' + hour + ':' + minute + ':' + second
                }
            },
            created() {
                this.myQuoteList(); // 出价记录
                this.myQuoteBrands(); // 我的出价品牌列表
                this.myQuoteSpecs(); // 我的出价产品型号列表
                // this.contractEntrustIndex(); // 列表
                // this.basisEntrustIndex() // 委托单位列表
            },
            // 解决表格fixed错位问题
            updated() {
                if (this.$refs.singleTable && this.$refs.singleTable.doLayout) {
                    this.$refs.singleTable.doLayout()
                }
            }
      }
  </script>
  
  <!-- Add "scoped" attribute to limit CSS to this component only -->
  <style scoped>
      .ystatus{
        width: 100%;
        text-align: center;
        color: #847f7f;
        cursor: default;
      }
      .wstatus{
        width: 100%;
      }
      .mains{
          border-radius: 5px;
      }
      .lanmu{
            /* width: 100%; */
            background: rgba(255, 255, 255, .8);
            border-radius: 10px;
            padding: 0 10px 0 40px;
            margin-bottom: 0;
      }
      .lanmu .top{
            display: inline-block;
            background: #fff6f6;
            width: 100px;
            text-align: center;
            line-height: 30px;
            border-bottom: 2px solid #eb3935;
            color: #000;
      }
      .sub{
          margin-top: 5px;
          gap: 12px;
      }
      .sub p{
          width: 160px;
          color: #7d7d7d;
          flex: 0 0 auto;
      }
      .caidan{
          flex: 1;
          /* margin-left: 20px;
          width: calc(100% - 135px); */
      }
      .caidan .cons li{
            line-height: 22px;
            padding: 3px 16px;
            border-radius: 6px;
            margin-right: 20px;
            cursor: pointer;
            color: #000;
            font-size: 14px;
      }
      .caidan .cons li.active{
          background: #eb3935;
          color: #fff;
      }
      .content{
          height: calc(100% - 100px);
        align-items: flex-start;
        gap: 12px;
      }
      .xuanx{
          width: 200px;
        background: #fff;
        height: 100%;
        border-radius: 10px;
        flex: 0 0 auto;
      }
      .xuanx .luodi{
          padding-bottom: 7px;
          margin: 0 24px;
            padding: 20px 0 10px;
            font-size: 14px;
            color: #666;
          border-bottom: 1px solid #e7e7e7;
      }
      .xuanx .luodi img{
          margin-right: 8px;
      }
      .sf .el-radio-group{
          width: 100%;
          padding: 10px 0;
      }
      .contents{
          /* margin-left: 20px;
        width: calc(100% - 155px); */
        height: 100%;
        /* border-radius: 10px; */
        flex: 1;
        overflow: hidden;
      }
      .caidans{
          margin-bottom: 16px;
          border-radius: 10px;
          /* background: #fff; */
          display: flex;
      }
      .caidans .plei{
          background: #fff;
          border-radius: 10px;
          flex: 1;
          margin-right: 12px;
      }
      .pro{
          border-radius: 10px;
          background: #fff;
          padding: 0 15px;
          height: calc(100% - 75px);
        overflow-y: scroll;
      }
      .pro .bt{
          display: inline-flex;
          padding-bottom: 20px;
          border-bottom: 1px solid #dfe6ec;
          position: sticky;
        top: 0;
        background: #fff;
        padding-top: 15px;
      }
      .pro .bt li{
          margin-right: 10px;
        background: #f8f8f8;
        border: 1px solid #e7e7e7;
        line-height: 50px;
        width: 164px;
        text-align: center;
        border-radius: 10px;
        box-sizing: border-box;
      }
      .pro .bt li:nth-child(2),
      .bcon .list li:nth-child(2){
          width: 360px;
      }
      .pro .bt li:nth-child(3),
      .bcon .list li:nth-child(3){
          width: 180px;
      }
      .pro .bt li:nth-child(4),
      .bcon .list li:nth-child(4){
          width: 554px;
      }
      .pro .bt li:nth-child(5),
      .bcon .list li:nth-child(5){
          width: 180px;
      }
      .pro .bt li:nth-child(6),
      .bcon .list li:nth-child(6){
          width: 180px;
      }
      .pro .bt li:nth-child(7),
      .bcon .list li:nth-child(7){
          width: 200px;
      }
      .pro .bt li:nth-child(8),
      .bcon .list li:nth-child(8){
          width: 400px;
      }
      .pro .bt li:nth-child(9),
      .bcon .list li:nth-child(9){
          width: 200px;
      }
      .pro .bt li:nth-child(10),
      .bcon .list li:nth-child(10){
          width: 240px;
      }
      .pro .bt li:nth-child(11),
      .bcon .list li:nth-child(11){
          width: 320px;
      }
      .pro .bt li:nth-child(12),
      .bcon .list li:nth-child(12){
          width: 400px;
          margin-right: 0;
      }
      .bcon{
          display: inline-block;
      }
      .bcon .list{
          padding: 20px 0;
          border-bottom: 1px solid #dfe6ec;
          font-size: 14px;
      }
      .bcon .list li{
          margin-right: 10px;
          width: 164px;
          text-align: center;
      }
      .bcon .list li:nth-child(2){
          text-align: left;
        white-space: pre-line;
        line-height: 25px;
      }
      .bcon .list li.t0{
          display: flex;
          align-items: center;
          justify-content: center;
      }
      .bcon .list li.t0 span{
          width: 15px;
        height: 15px;
        background: #03cc06;
        border-radius: 50%;
        margin-right: 5px;
      }
      .bcon .jl{
          justify-content: flex-end;
      }
      .bcon .jl .btns{
          background: #df3632;
          width: 80px;
          line-height: 40px;
          color: #fff;
          border-radius: 5px;
          margin-left: 30px;
          cursor: pointer;
      }
      .bcon .jl .tiao{
          width: 120px;
        line-height: 25px;
        background: #ffdfdf;
        height: 25px;
        border-radius: 5px;
        overflow: hidden;
      }
      .bcon .jl .tiao p{
          background: #eb3935;
          height: 100%;
      }
      .bcon .date{
          border: 1px solid #eb3935;
          color: #eb3935;
        line-height: 40px;
        border-radius: 5px;
      }
      .bcon .tip p{
          white-space: pre-line;
        line-height: 25px;
      }
      .bcon .time{
          background: #eb3935;
          color: #fff;
        line-height: 32px;
        border-radius: 5px;
      }
      .bcon .list li:last-child{
          text-align: left;
          line-height: 25px;
      }
      .caidans .cons{
          padding: 10px 15px;
      }
      .caidans .cons li{
          line-height: 20px;
        padding: 3px 12px;
        border-radius: 4px;
        margin-right: 25px;
        cursor: pointer;
        color: #666;
        font-size: 14px;
        border: 1px solid #e7e7e7;
        max-width: 280px;
        display: inline-block;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      .caidans .cons li.active{
          background: #eb3935;
        color: #fff;
      }
      .sf .radiogroup{
          width: 100%;
      }
      .sf label{
          position: relative;
          margin: 0;
        padding: 8px 0 8px 24px;
        display: flex;
        height: 20px;
      }
      .sf label.is-checked{
          background: #fff6f6;
      }
      .sf label.is-checked:after{
          content: "";
        position: absolute;
        right: 0;
        top: 0;
        width: 6px;
        height: 100%;
        background: #eb3935;
        border-top-left-radius: 6px;
        border-bottom-left-radius: 6px;
      }
      .sf /deep/ .el-radio__label{
          padding-left: 12px;
          color: #7c7c7c;
          line-height: 20px;
      }
      .sf /deep/ .el-radio__inner{
          border: 1px solid #dcdfe6;
            width: 20px;
            height: 20px;
            border-radius: 2px;
      }
      .sf /deep/ .el-radio__input.is-checked .el-radio__inner{
          border-color: #eb3935;
        background-color: #eb3935;
      }
      .sf /deep/ .el-radio__inner::after{
          -webkit-box-sizing: content-box;
            box-sizing: content-box;
            content: "";
            border: 2px solid #fff;
            background: transparent;
            border-radius: 0;
            outline: none;
            border-left: 0;
            border-top: 0;
            height: 10px;
            left: 6px;
            position: absolute;
            top: 1px;
            -webkit-transform: rotate(45deg) scaleY(0);
            transform: rotate(45deg) scaleY(0);
            width: 4px;
            -webkit-transition: -webkit-transform .15s ease-in .05s;
            transition: -webkit-transform .15s ease-in .05s;
            transition: transform .15s ease-in .05s;
            transition: transform .15s ease-in .05s, -webkit-transform .15s ease-in .05s;
            -webkit-transform-origin: center;
            transform-origin: center;
      }
      .sf /deep/ .el-radio__input.is-checked .el-radio__inner::after{
          -webkit-transform: rotate(45deg) scaleY(1);
        transform: rotate(45deg) scaleY(1);
        transition: none;
      }
      .jldialog /deep/ .el-dialog__title{
          font-weight: bold;
      }
      .jldialog /deep/ .el-dialog__header{
          padding: 0;
          text-align: center;
          line-height: 80px;
          background: #ffdd00;
          color: #000;
      }
      .jldialog .list{
          flex-wrap: wrap;
          padding: 6px 0 11px;
      }
      .jldialog .list div{
          width: 50%;
          margin-bottom: 2px;
      }
      .jldialog .list div:last-child{
          width: 100%;
      }
      .jldialog .name{
          padding-bottom: 11px;
        border-bottom: 1px solid #e7e7e7;
        color: #000;
        font-size: 16px;
      }
      .jldialog .xx{
          padding: 10px;
        background: #f8f8f8;
        border-radius: 5px;
      }
      .jldialog .canyu{
          padding: 10px;
          border-radius: 5px;
          margin: 10px 0;
          background: #f8f8f8;
      }
      .jldialog .canyu .line{
          height: 15px;
          background: #ffdfdf;
          display: block;
          margin: 5px 0;
      }
      .jldialog .canyu .tt{
          text-align: center;
          color: #000;
          justify-content: center;
          align-items: center;
      }
      .jldialog .chujia{
          background: #f8f8f8;
          min-height: 134px;
          border-radius: 5px;
      }
      .jldialog .chujia .zanwu{
          line-height: 134px;
          text-align: center;
      }
      .jldialog .bd{
          margin-top: 6px;
          justify-content: space-between;
      }
      .jldialog .bd button{
          outline: none;
          box-shadow: none;
          width: 200px;
          line-height: 54px;
          border-radius: 5px;
          text-align: center;
          background: #f59c9a;
          color: #fff;
          font-size: 18px;
          border: 0;
          cursor: pointer;
      }
      .jldialog .bd .top{
          margin-bottom: 10px;
          justify-content: space-between;
      }
      .jldialog .bd .input{
          width: 452px;
      }
      .jldialog .bd input{
          width: 155px;
        border: 0;
        border: 1px solid #dcdfe6;
        border-radius: 5px;
        line-height: 40px;
        padding: 0 15px;
        color: #606266;
      }
      .jldialog .bd .bot .el-select{
          flex: 1;
      }
      .tableWrap {
        padding: 12px;
        background: #fff;
        border-radius: 6px;
        position: relative;
        z-index: 0;
        height: calc(100% - 24px);
    }
    /* 基础滚动条样式 */
    .tableWrap /deep/ .el-table--scrollable-x .el-table__body-wrapper::-webkit-scrollbar{
        width: 8px;
        height: 8px;
    }
    /* 轨道样式 */
    .tableWrap /deep/ .el-table--scrollable-x .el-table__body-wrapper::-webkit-scrollbar-track {
        background: #F1F1F1;
        border-radius: 10px;
    }
    /* 滑块样式 */
    .tableWrap /deep/ .el-table--scrollable-x .el-table__body-wrapper::-webkit-scrollbar-thumb {
        background: #c1c1c1;
        border-radius: 10px;
    }
    /* 悬停效果 */
    .tableWrap /deep/ .el-table--scrollable-x .el-table__body-wrapper::-webkit-scrollbar-thumb:hover {
        background: #a8a8a8;
    }
    .cleck-wrap .btn-search{
        margin-bottom: 10px;
    }
    .cleck-wrap .check-box {
        border-radius: 3px;
        border: 1px solid #e4e7ed;
        padding: 5px 0;
        font-weight: 400;
    }
    .scrollBox{
        max-height: 220px;
        overflow-x: hidden;
        overflow-y: auto;
    }
    .scrollBox .el-radio-group{
        padding: 0;
    }
    .scrollBox label{
        height: 26px;
        padding: 0 10px;
        align-items: center;
    }
    .scrollBox /deep/ .el-radio__inner{
        width: 14px;
        height: 14px;
        border-radius: 2px;
    }
    .scrollBox label.is-checked{
        background-color: #f5f7fa;
      }
      .scrollBox label.is-checked:after{
          display: none;
      }
      .scrollBox /deep/ .el-radio__inner::after{
          width: 3px;
          height: 8px;
          left: 4px;
          border-width: 1px;
      }
      .scrollBox /deep/ .el-radio__label{
          color: #606266;
      }
      .footerWrap{
          margin-top: 10px;
          display: flex;
          justify-content: flex-end;
      }
      .footerWrap .btnWrap .el-button{
          font-size: 14px;
          padding: 7px 21px;
      }
      .footerWrap .btnWrap .el-button:hover{
          background: #f8f8f8;
          color: #333;
          border-color: #e7e7e7;
      }
      .footerWrap /deep/ .nl-need-cancel-btn{
          background: #f8f8f8;
        border-color: #e7e7e7;
        color: #333;
      }
      .footerWrap /deep/ .nl-need-sure-btn{
          background: #eb3935;
        border-color: #eb3935;
        color: #fff;
      }
      .footerWrap .btnWrap .el-button.nl-need-sure-btn:hover{
          background: #eb3935;
        border-color: #eb3935;
        color: #fff;
      }
      .companyCredit {
        vertical-align: -.15em;
        display: inline-block;
        width: 14px;
        height: 14px;
        border-radius: 8px;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        margin-right: 4px;
        background: #03cc06;
    }
    .orders_price{
        display: flex;
        align-items: center;
        justify-content: right;
    }
    .orders_price .item{
        width: 20px;
        height: 20px;
        border-radius: 50%;
        border: 1px solid #0e86eb;
        color: #0e86eb;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .customProgress {
        width: 180px;
        font-size: 14px;
        color: #333;
        margin-left: 6px;
    }
    .unborder {
        border: none;
        background-color: #ffdfdf;
    }
    .scheduleCont_1_left_1 .un_xg_1_3_1 {
        position: absolute;
        top: 0;
        left: 0;
        width: 0;
        height: 100%;
        border-radius: 3px;
        background-image: -webkit-gradient(linear, left top, right top, from(#eb3935));
        background-image: linear-gradient(90deg, #eb3935);
    }
    .scheduleCont_1_left_1{
        position: relative;
        width: 100%;
        height: .8rem;
        border-radius: 3px;
        overflow: hidden;
    }
    .btnPickDragon {
        width: 68px;
        height: 30px;
        font-size: 14px;
        color: #fff;
        padding: 4px 2px;
        border-radius: 4px;
        border: 0;
        background-color: #eb3935;
    }
    .border-time{
        padding: 4px;
        border-radius: 6px;
        border: 1px solid #eb3935;
        text-align: center;
        color: #eb3935;
    }
    .limitTime {
        font-size: 14px;
        line-height: 22px;
        color: rgb(255, 255, 255);
        text-align: center;
        background-color: rgb(204, 204, 204);
        padding: 0px;
        border-radius: 4px;
        margin: 0px auto;
        background-color: rgb(235, 87, 50);
    }
    .el-table{
        color: #333;
    }
    .tableWrap /deep/ .el-table .cell{
        text-align: center;
    }
    .tableWrap /deep/ .el-table__header th.el-table__cell{
        padding: 0 0 12px;
    }
    .tableWrap /deep/ .el-table th.el-table__cell>.cell{
        padding-left: 4px;
        padding-right: 4px;
    }
    .tableWrap /deep/ .el-table th.el-table__cell>.cell .filterHeader{
        padding-left: 4px;
        padding-right: 4px;
        height: 42px;
        line-height: 42px;
        background-color: #f8f8f8;
        border-radius: 6px;
        border: 1px solid #e7e7e7;
        text-align: center;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #666;
        font-size: 14px;
        font-weight: 400;
    }
    .tableWrap /deep/ .el-table th.el-table__cell>.cell .filterHeader .icon{
        width: 1em;
        height: 1em;
        display: inline-block;
        vertical-align: text-bottom;
        margin-left: 4px;
    }
    .scrollBox /deep/ .el-checkbox__input.is-checked+.el-checkbox__label{
        color: inherit;
    }
    .scrollBox /deep/ .el-checkbox__input.is-checked .el-checkbox__inner, .scrollBox /deep/ .el-checkbox__input.is-indeterminate .el-checkbox__inner{
        background-color: #eb3935;
        border-color: #eb3935;
    }
    .tableTop{
        margin: 12px 0;
    }
    .tableTop .text_top{
        margin-left: 10px;
        font-size: 14px;
        color: #666;
    }
    .pageWrap{
        text-align: right;
        margin: 7px 10px 0 0;
    }
    .tableWrap .price-items {
        -ms-flex-negative: 0;
        flex-shrink: 0;
        display: inline-block;
        padding: 2px 5px;
        margin: 3px 5px 3px 3px;
        border-radius: 3px;
        width: 190px;
    }
    .tableWrap .need-order-table-content{
        display: inline-block;
        white-space: nowrap;
    }
    .tableWrap .need-order-table-content .tradePrice {
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-pack: center;
        -ms-flex-pack: center;
        justify-content: center;
        text-align: center;
        width: 70px;
        height: 30px;
        font-weight: 700;
        color: #eb3935;
        background-color: #f8f8f8;
        border-radius: 4px;
    }
    .tableWrap .need-order-table-content div, .tableWrap .need-order-table-content span {
        white-space: nowrap;
    }
    .tableWrap .xgbaojia, .tableWrap .shenhe{
        gap: 5px;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .tableWrap .xgbaojia /deep/ .el-button, .tableWrap .shenhe /deep/ .el-button{
        padding: 9px;
    }
    .xgDialog /deep/ .el-form-item{
        display: flex;
    }
    .xgDialog /deep/ .el-form-item:nth-child(3){
        margin-bottom: 0;
    }
    .xgDialog /deep/ .el-form-item:nth-child(4){
        padding-left: 40px;
        margin-bottom: 0;
    }
    .xgDialog /deep/ .el-form-item__content{
        flex: 1;
    }
    .xgDialog /deep/ .el-form-item__content .el-select{
        width: 100%;
    }
  </style>


// WEBPACK FOOTER //
// src/components/chujia.vue